class CartDrawer {
  constructor() {}
  
  setUpClicks(){
    const remove = document.getElementsByClassName('cart-drawer-item-remove');
    for (var i = 0; i < remove.length; i++) {
      let ind = remove[i].getAttribute('data-id');
      remove.item(i).addEventListener('click', (event) => {
        event.preventDefault();
        this.updateCartContents({'id': ind, 'quantity': 0});
      });
    }
  }

  getCartContents(){
    let total = 0;
    let cartUrl = window.location.protocol + '//' + window.location.host + '/cart/';
    fetch('/cart.js')
    .then((response) => response.json())
    .then((data) => {
      let str = '';
      data.items.forEach(function(product, index){
        cartUrl += product.variant_id+':'+product.quantity+',';
        total += product.line_price;
        let price = new Money;
        str += '<div class="cart-drawer-item flex justify-start">'
                +'<div class="cart-drawer-item-image" data-bgratio="1" style="background: url('+product.image+') no-repeat center/cover;"></div>'
                +'<div class="cart-drawer-item-body flex-col align-start justify-between">'
                  +'<div class="cart-drawer-item-header flex-col align-start justify-start">'
                    +'<h3 class="cart-drawer-item-title">'+product.product_title+'</h3>'
                    +'<div class="cart-drawer-item-price">'+price.formatMoney(product.line_price)+'</div>'
                  +'</div>'
                  +'<div class="cart-drawer-item-qty"><span>Quantity:</span>'+product.quantity+'</div>'
                  +'<a href="#" class="cart-drawer-item-remove" data-id="'+product.variant_id+'"><span>Remove</span></a>'
                +'</div>'
              +'</div>';
      })
      document.getElementById('cart_drawer_items').innerHTML = str;
      scaleBgImages();
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally(() => {
      this.setUpClicks();
      let amount = new Money;
      $('#cart_drawer_total').html(amount.formatMoney(total));
      $('#cart_drawer_share').attr('href', 'mailto:?subject=I%20LOVE%20this%20article%20and%20thought%20of%20you%21&body='+encodeURIComponent(cartUrl));
      $('#cart_drawer_link').attr('href', cartUrl);
      $('#checkout_link').attr('href', cartUrl);
    });
  }

  updateCartContents(body){
    let _ = this;
    jQuery.post('/cart/change.js', body, function(){
      _.getCartContents();
    }, 'json');
  }
}
